<template>
  <div>
    <headEnterprise></headEnterprise>
    <breadCrum :breadCrumList="breadCrumList"></breadCrum>
    <div class="supply_detail_content warp">
      <div class="supply_detail_left">
        <div class="supply_detail_img">
          <img :src="currentSelectImg" alt="" />
        </div>
        <div v-swiper:mySwiper="swiperOption">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide box"
              v-for="(item, index) in productImgList"
              :key="index"
              :class="current == index ? 'active' : ''"
              @click="changeCurrent(index)"
            >
              <img :src="item" alt="" />
            </div>
          </div>
        </div>
        <user-operation
          v-if="detail.title"
          @onCollection="goCollection(6)"
          @callCollection="callCancelcollection()"
          style="margin-top: 10px"
          :shareObj="detail"
          :notStatus="status"
        ></user-operation>
      </div>
      <div class="supply_detail_right" v-if="detail">
        <h2>{{ detail.title }}</h2>
        <div class="supply_detail_price">
          <p>
            价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格：<span class="money"
              >{{ detail.price }}</span
            >
          </p>
          <!-- <p>起订货量：<span>>5个</span></p> -->
        </div>
        <div class="supply_detail_address">
          <p v-if="detail.address">发货地址：{{ detail.address.replace(/,/g, "/") }}</p>
          <p>发货期限：{{ detail.timeLimit }}</p>
        </div>
        <div class="supply_detail_btn" @click="onView()">查看联系方式</div>
        <p class="suupy_text">{{ panter.mobile }}</p>
      </div>
    </div>
    <!-- 推荐产品 -->
    <div class="recommended_products warp">
      <h3 class="tips" style="margin-top: 30px">公司推荐产品</h3>
      <ul :class="[productList.length ==2 ?'recom_list':'']">
        <li @click="toDetail(item)" v-for="(item, index) in productList" :key="index">
		  <div class="recom_list_mater">
			  <img :src="item.cover" alt="" />
		  </div>
          <div class="recommended_products_info">
            <p>{{ item.title }}</p>
            <span>浏览数：{{ item.readcount }}</span>
          </div>
          <div class="recommended_products_price">
            <p>{{ item.companyname }}</p>
            <span class="money">{{ item.price }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="warp mb-60" style="margin-top: 40px">
      <el-container>
        <el-aside width="330px">
          <base-info @onCollection="goCollection_company(7)" :notStatus="status2"></base-info>
          <!-- <div class="saide_middle">
            <div class="saide_mater">
              <p>产品分类</p>
            </div>
            <div class="saide_tree">
              <el-tree :data="data" show-checkbox node-key="id"> </el-tree>
            </div>
          </div> -->
        </el-aside>
        <el-main style="padding-left: 32px">
          <h3 class="tips">产品参数</h3>
          <ul class="product_desc" v-if="detail.attr != null && detail.attr.length>6">
            <li v-for="(item, index) in detail.attr.split(',')" :key="index">
              {{ item }}
            </li>
          </ul>
          <div class="product_nox info_detail_desc" style="margin-top: 20px" v-html="detail.content"></div>
        </el-main>
      </el-container>
    </div>
    <footCom></footCom>
  </div>
</template>

<script>
import { routerGoNewpage } from "@/utils/index";
import { addCollection, getusercontact, iscollection,addBrowse, cancelcollection,} from "@/api/coment";
import { systemList } from "@/api/company";
import headEnterprise from "../../common/headEnterprise";
import footCom from "../../common/footCom";
import { getToken } from "@/utils/auth";
import titleHead from "../../common/titleHead";
import userOperation from "../../common/userOperation";
import baseInfo from "@/components/companyintroCard";
import breadCrum from "@/common/breadCrum";
import { getProduct, getProductDetail } from "@/api/information";
export default {
  components: {
    titleHead,
    userOperation,
    headEnterprise,
    footCom,
    baseInfo,
    breadCrum,
  },
  data() {
    return {
      obj: {
        title: "污水处理设备",
        content:
          "公司主营产品及服务包括：金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...",
      },
      breadCrumList: [{ name: "供需平台", url: "/supply_demand" },{name:'',url:''}],
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 10, // 每张的间距
        slidesPerGroup: 1,
      },
      current: 0,
      id: "",
      detail: "",
      productList: [],
      productImgList: [],
      currentSelectImg: "",
      panter: {},
      status: false,
      status2: false,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getProductDetail(this.id);
    if (this.id == null) {
    }
    if (getToken() != undefined) {
      this.getIscollection();
      this.getcompnayIscollection();
      this.getAddBrowse();
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        this.id = this.$route.query.id;
        this.getProductDetail(this.id);
      },
    },
  },
  methods: {
    getsystemList(id) {
      systemList()
        .then((res) => {
          let name = res.data.filter((item) => {
            return item.id == id;
          })[0].name;
          //  this.breadCrumList.push({url:`/classification_list?categroyid=${id}`});
          //  this.breadCrumList.push({name,url:`/classification_list?categroyid=${id}`});
        })
        .catch((err) => {});
    },
    toDetail(item) {
      // routerGoNewpage("/supply_detail",{id:item.id});
      this.$router.push({ path: "/supply_detail", query: { id: item.id } });
    },
    //获取推荐产品
    getRecommendProduct(id) {
      getProduct({
        curPage: 1,
        limit: 4,
        recommend: 1,
        userid: id,
      }).then((res) => {
        if(res.code == 0){
           this.productList = res.page.list;
        }
      });
    },
    //获取产品详情
    getProductDetail(id) {
      getProductDetail({
        id: id,
      })
        .then((res) => {
          if (res.data && res.code == 0) {
            this.detail = res.data;
            this.getMate(res.data);
            if(res.data.images && res.data.cover && res.data.images=="" ){
               this.currentSelectImg=res.data.cover;
            }else if(res.data.images) {
               this.productImgList = this.detail.images ? this.detail.images.split(",") : [];
               this.currentSelectImg = this.productImgList[0];
            }
            this.getCompanyDetail(this.detail.userId);
            this.getRecommendProduct(this.detail.userId);
            this.getsystemList(this.detail.categoryId);
            this.breadCrumList[1].name = res.data.title;
          }
        })
        .catch((err) => {});
    },
    changeCurrent(index) {
      this.current = index;
      this.currentSelectImg = this.productImgList[index];
    },
    //获取公司信息
    getCompanyDetail(id) {
      sessionStorage.setItem("corporateId", id);
      this.$store.dispatch("company/getBaseInfo");
    },
    //产品收藏
    goCollection(goodsType) {
      let params = {
        goodsId: this.id,
        goodsType: goodsType,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "收藏成功！",
              type: "success",
            });
          }
        })
        .catch((err) => {});
    },
    //产品取消收藏
     callCancelcollection(){
       let params = {
          goodsid:this.id,
          goodstype:"6"
       }
       cancelcollection(params).then((res)=>{
         if(res.code == 0){
            this.$message({
              type:"success",
              message:"取消收藏"
            })
         }
       }).catch((err)=>{})
     },
    //企业收藏
    goCollection_company(goodsType) {
      let params = {
        goodsId: this.detail.userId,
        goodsType: goodsType,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "收藏成功！",
              type: "success",
            });
          }
        })
        .catch((err) => {});
    },
    //查看联系方式
    onView() {
      if (getToken() != undefined) {
        if (this.detail.userId != null) {
          let params = {
            userid: this.detail.userId,
		    goodsid:this.id,
			goodstype:6
          };
          if (Object.keys(this.panter).length == 0) {
            getusercontact(params)
              .then((res) => {
                if (res.code == 0) {
                  this.panter = res.data;
                }
              })
              .catch((err) => {});
          } else {
            return;
          }
        } else {
          this.$message({
            message: "暂无联系方式",
            type: "info",
            duration: 2000,
          });
        }
      } else {
        this.$router.push("/login");
      }
    },
    //查看新产品收藏状态
    getIscollection() {
      let params = {
        goodsid: this.id,
        goodstype: 6,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.status = res.data;
          }
        })
        .catch((err) => {});
    },
    //查看公司收藏状态
    getcompnayIscollection() {
      let params = {
        goodsid: this.detail.userId,
        goodstype: 7,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.status2 = res.data;
          }
        })
        .catch((err) => {});
    },
    getMate(data) {
      var metas = document.getElementsByTagName("meta");
      if(data.seokeywords && data.seokeywords != null){
        metas[0].name = "keywords";
        metas[0].content = data.seokeywords;
      }
      if(data.seodescription && data.seodescription != null){
        metas[1].name = "description";
        metas[1].content = data.seodescription;
      }
      document.getElementsByTagName("title")[0].innerText = data.title + "_智污邦环保服务平台";
    },

    //浏览数增加
    getAddBrowse() {
      let postData = {
        goodsId: this.id,
        goodsType: 6,
        id: this.$store.state.user.userInfo.data.userId,
      };
      addBrowse(postData)
        .then((res) => {
          if (res.code == 0) {}
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped lang="less">
.tips {
  position: relative;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding-left: 10px;
  margin-bottom: 10px;
  &::before {
    position: absolute;
    left: 0;
    bottom: 4px;
    display: inline-block;
    content: "";
    width: 5px;
    height: 23px;
    background: #ff7302;
  }
}
.money {
  font-size: 20px;
  font-family: Arial;
  font-weight: 400;
  color: #ff7302;
  &::before {
    display: inline-block;
    width: 15px;
    height: 15px;
    content: "";
    background: url("../../assets/images/money.png") no-repeat center/100%;
    vertical-align: middle;
  }
}
.supply_detail_content {
  display: flex;
  .supply_detail_left {
    width: 40%;
    margin-right: 20px;
    .supply_detail_img {
      margin-bottom: 10px;
      position: relative;
      width: 100%;
      height: 300px;
      overflow: hidden;
      border: 1px solid #d2d2d2;
      // background: url("../../assets/images/supply_detail_bg.png") no-repeat
      //   center/cover;
      img {
        // width: 150px;
        // height: 220px;
        width: 100%;
        height: 100%;
        object-fit: fill;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
      }
    }
    .swiper-wrapper {
      .box {
        cursor: pointer;
        height: 60px;
        position: relative;
        background: #fbfbfb;
        border: 1px solid #d2d2d2;

        img {
          width: 36px;
          height: 52px;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          margin: auto;
        }
      }
      .active {
        border: 2px solid #7bc62a;
      }
    }
  }
  .supply_detail_right {
    width: 60%;
    h2 {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .supply_detail_price {
      margin: 10px 0;
      // padding: 23px 0 15px 20px;
      background: #fbfbfb;
      height: 42px;
      line-height: 42px;
      padding: 0px 20px;
      // height: 112px;
      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
        &:nth-of-type(1) {
          span {
            font-size: 22px;
            font-family: Arial;
            font-weight: 400;
            color: #ff7302;
          }
        }
      }
    }
    .supply_detail_address {
      margin-top: 10px;
      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        padding-left: 19px;
        &:nth-of-type(1) {
          margin-bottom: 10px;
        }
      }
    }
    .supply_detail_btn {
      width: 20%;
      text-align: center;
      background: #68be31;
      border-radius: 3px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      padding: 5px 0;
      cursor: pointer;
      margin-top: 40px;
    }
  }
}
.recommended_products {
  ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
	flex-wrap: wrap;
    li {
	  width:23%;
	  overflow: hidden;
      &:last-of-type {
        margin-right: 0;
      }
	  .recom_list_mater{
		overflow: hidden;
		width: 100%;
        height: 150px;
		img{
		   width:100%;
		   height: 100%;
		   transition: all 0.5s;
		   &:hover{
		      cursor: pointer;
		      transform: scale(1.2);
		   }
		}
	  }
      .recommended_products_info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
          max-width: 160px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        span {
          font-size: 15px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
        }
      }
      .recommended_products_price {
        display: flex;
        flex-direction: column;
        p {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
	&::after{
	   content: '';
	   width: 23%;
	}
  }
  .recom_list::after{
	content: '';
	width: 46%;
  }
}
.product_desc {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #eeeeee;
  li {
    width: 30%;
    margin: 15px 0;
    padding: 0 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
}
.product_material {
  margin: 20px 0;
  li {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-bottom: 10px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
.product_img {
  width: 100%;
  height: 300px;
}
.el-aside {
  background: white;
  height: auto;
}
.el-main {
  text-align: inherit;
  padding: 0;
}
.fdc {
  align-items: center;
}
.aside_left {
  background: #ffffff;
  border: 1px solid #ededed;
  padding: 20px 20px;
}
.left_top {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.portrait {
  width: 107px;
  height: 107px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.portrait img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.wire {
  margin-top: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #999999;
}
.wire p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.left_bat {
  text-align: left;
  margin-top: 20px;
  margin-left: 30px;
}
.left_bat p span:first-child {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.left_bat p span:last-child {
  flex: 1;
  margin-left: 10px;
  margin-right: 20px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.left_bartext {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.saide_middle {
  margin-top: 30px;
  background: #f8f8f8;
  color: #333;
  text-align: center;
  border-top: 2px solid #99cf2a;
  padding: 15px 15px;
  text-align: left;
}
.saide_mater {
  padding-bottom: 20px;
  border-bottom: 1px dashed #e1e1e1;
}
.saide_mater p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.saide_tree {
  margin-top: 30px;
}
.el-tree {
  background: #f8f8f8;
}
.suupy_text {
  margin-top: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
}
// /deep/.product_nox p img{
//   width: 100%;
//   height:100%;
// }
</style>



// WEBPACK FOOTER //
// src/view/supply_demand/supply_detail.vue